module.exports = __webpack_public_path__ + "img/button-text-italic-on.90a0873.svg";